import { useEffect, useState } from "react";
import { ConsentProvider } from "@/consent/ConsentContext";
import ConsentBanner from "./ConsentBanner";
import LegalPage from "./LegalPage";
import { DATENSCHUTZ_SECTIONS, IMPRESSUM_SECTIONS } from "./legalContent";

function LegalInner({ lenisRef, started }) {
  const [route, setRoute] = useState(window.location.hash);

  useEffect(() => {
    const onHash = () => setRoute(window.location.hash);
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);

  const legal =
    route === "#/datenschutz" ? "datenschutz" : route === "#/impressum" ? "impressum" : null;

  useEffect(() => {
    if (legal) {
      lenisRef.current?.stop();
      document.body.style.overflow = "hidden";
    } else if (started) {
      lenisRef.current?.start();
      document.body.style.overflow = "";
    }
  }, [legal, started, lenisRef]);

  return (
    <>
      <ConsentBanner />
      {legal === "datenschutz" && (
        <LegalPage testid="datenschutz-page" title="Datenschutzerklärung" sections={DATENSCHUTZ_SECTIONS} />
      )}
      {legal === "impressum" && (
        <LegalPage testid="impressum-page" title="Impressum" sections={IMPRESSUM_SECTIONS} />
      )}
    </>
  );
}

export default function LegalSetup({ children, lenisRef, started }) {
  return (
    <ConsentProvider>
      {children}
      <LegalInner lenisRef={lenisRef} started={started} />
    </ConsentProvider>
  );
}
